import { lintSourceConfig } from "components/organisms/editor/codemirror/linting";
import { createLinter } from "components/organisms/manuscript/editor/latex/language";
import { latexLinter } from "./linter/latex-linter.js";

export function linting() {
    return createLinter(latexLinter, lintSourceConfig);
}
